"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _redux = require("redux");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _yearlyPerformance = _interopRequireDefault(require("./yearlyPerformance"));

var _monthlyPerformance = _interopRequireDefault(require("./monthlyPerformance"));

var _dailyPerformance = _interopRequireDefault(require("./dailyPerformance"));

var _minutePerformance = _interopRequireDefault(require("./minutePerformance"));

var _minuteBattery = _interopRequireDefault(require("./minuteBattery"));

var _dailyBattery = _interopRequireDefault(require("./dailyBattery"));

var _fsDispatch = _interopRequireDefault(require("./fsDispatch"));

var _sitePower = _interopRequireDefault(require("./sitePower"));

var _contractGenDaily = _interopRequireDefault(require("./contractGenDaily"));

var _contractGenMonthly = _interopRequireDefault(require("./contractGenMonthly"));

var _peers = _interopRequireDefault(require("./peers"));

var _peerV = _interopRequireDefault(require("./peerV2"));

var _cumulativeContract = _interopRequireDefault(require("./cumulativeContract"));

var _cumulativePeerDaily = _interopRequireDefault(require("./cumulativePeerDaily"));

var _cumulativePeerMonthly = _interopRequireDefault(require("./cumulativePeerMonthly"));

var _cumulativePeerDailyV = _interopRequireDefault(require("./cumulativePeerDailyV2"));

var _cumulativePeerMonthlyV = _interopRequireDefault(require("./cumulativePeerMonthlyV2"));

var _cumulativeProductionDaily = _interopRequireDefault(require("./cumulativeProductionDaily"));

var _cumulativeProductionMonthly = _interopRequireDefault(require("./cumulativeProductionMonthly"));

var _cumulativeProductionDailyV = _interopRequireDefault(require("./cumulativeProductionDailyV2"));

var _cumulativeProductionMonthlyV = _interopRequireDefault(require("./cumulativeProductionMonthlyV2"));

var _productOffering = _interopRequireDefault(require("./productOffering"));

var _orangeDataPoints = _interopRequireDefault(require("./orangeDataPoints"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var combinedReducers = (0, _redux.combineReducers)({
  contractGenDaily: _contractGenDaily["default"],
  contractGenMonthly: _contractGenMonthly["default"],
  dailyBattery: _dailyBattery["default"],
  dailyPerformance: _dailyPerformance["default"],
  fsDispatch: _fsDispatch["default"],
  minuteBattery: _minuteBattery["default"],
  minutePerformance: _minutePerformance["default"],
  peer: _peers["default"],
  peerV2: _peerV["default"],
  productOffering: _productOffering["default"],
  rpcCumulativeContract: _cumulativeContract["default"],
  rpcCumulativePeerDaily: _cumulativePeerDaily["default"],
  rpcCumulativePeerDailyV2: _cumulativePeerDailyV["default"],
  rpcCumulativePeerMonthly: _cumulativePeerMonthly["default"],
  rpcCumulativePeerMonthlyV2: _cumulativePeerMonthlyV["default"],
  rpcCumulativeProductionDaily: _cumulativeProductionDaily["default"],
  rpcCumulativeProductionDailyV2: _cumulativeProductionDailyV["default"],
  rpcCumulativeProductionMonthly: _cumulativeProductionMonthly["default"],
  rpcCumulativeProductionMonthlyV2: _cumulativeProductionMonthlyV["default"],
  rpcDailyBattery: _dailyBattery["default"],
  rpcMonthlyPerformance: _monthlyPerformance["default"],
  rpcOrangeDataPoints: _orangeDataPoints["default"],
  rpcYearlyPerformance: _yearlyPerformance["default"],
  sitePower: _sitePower["default"]
});
var store = (0, _redux.createStore)(combinedReducers, (0, _redux.applyMiddleware)(_reduxThunk["default"]));
var _default = store;
exports["default"] = _default;